module.exports = __webpack_public_path__ + "media/images/btn_new_season-cd63f782d4c20506b26ff8af13ca245d.gif";